import {Component, HostListener, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SearchResult} from "../../../common/interfaces/SearchResult";
import {Router} from "@angular/router";
import {Merchant} from "../../../common/interfaces/Merchant";
import {Product} from "../../../common/interfaces/Product";
import {Category} from "../../../common/interfaces/Category";
import {MerchantApi} from "../../../common/apis/merchant-api";

@Component({
  selector: 'custom-search-bar',
  templateUrl: './custom-search-bar.component.html',
  styleUrls: ['./custom-search-bar.component.scss']
})
export class CustomSearchBarComponent implements OnInit {

  options: SearchResult = {
    merchants: [],
    categories: [],
    products: []
  };
  formGroup: FormGroup;
  charactersToSearch: string = "";
  lastEventDate: number = Date.now();
  timeoutId: ReturnType<typeof setTimeout>;
  fetchingResults: boolean = false

  constructor(
    private merchantApi: MerchantApi,
    private fb: FormBuilder,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.formGroup = this.fb.group({
      'search': ['']
    })
    this.formGroup.get('search')!.valueChanges.subscribe(response => {
      if (response !== this.charactersToSearch) {
        this.charactersToSearch = response
        this.lastEventDate = Date.now();
        this.timeoutId = setTimeout(() => {
          this.fetchSearchResults(response)
        }, 1000);
      } else {
        clearTimeout(this.timeoutId);
        this.emptyOptionsArray();
      }
    });
  }

  fetchSearchResults(response: string) {
    if (Date.now() - this.lastEventDate > 1000) {
      // this.filterData(response);
      if (response.length > 0) {
        this.getNames(response);
      } else {
        // Clear search results. Not enough characters.
        this.emptyOptionsArray();
      }
    } else {

    }
  }

  getNames(text: string) {
    this.charactersToSearch = text
    this.fetchingResults = true
    this.merchantApi.search(1, text).subscribe({
      next: (response) => {
        this.fetchingResults = false
        this.options = {
          merchants: response.data,
          products: [],
          categories: []
        }
      },
      error: (_) => {
        this.fetchingResults = false
      }
    })
  }

  emptyOptionsArray() {
    this.options.merchants = [];
    this.options.categories = [];
    this.options.products = [];
  }

  onOptionSelected(option: Merchant | Product | Category) {
    // Navigate to the new page with the selected item value
    console.log("router = " + this.router);

    if ('slug' in option) {
      this.router.navigate(['/page/' + option.slug]).then(success => {
        if (success) {
          console.log('Navigation was successful!');
          // Perform other actions here
        } else {
          console.log('Navigation failed!');
          // Handle navigation failure
        }
      }).catch(error => {
        console.error('Navigation error:', error);
        // Handle any unexpected errors
      })
    } else {
      console.log("Option selected", option)
    }
    // this.router.navigate(['/merchant'], selectedItemValue)
  }

  goToMerchant(merchant: Merchant) {
    this.options.merchants = []
    this.charactersToSearch = ""
    this.formGroup.get('search')?.reset()
    this.router.navigate(['/page/' + merchant.slug])
  }

  openRestaurants() {
    if (this.charactersToSearch.trim().length > 0) {
      this.router.navigate(["/restaurants"], {
        queryParams: {
          text: this.charactersToSearch.trim()
        }
      })
    } else {
      this.router.navigate(["/restaurants"])
    }
  }

  openProducts() {

  }

  openCategories() {

  }

  @HostListener('keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === "Enter") {
      if (this.charactersToSearch.trim().length > 0) {
        this.router.navigate(["/restaurants"], {
          queryParams: {
            text: this.charactersToSearch.trim()
          }
        })
      } else {
        this.router.navigate(["/restaurants"])
      }
    }
  }

}
